import React from "react";
import PublicNavbar from "@/components/PublicNavbar";
import PublicFooter from "@/components/PublicFooter";
import WhatsAppButton from "@/components/WhatsAppButton";
import { RefreshCcw } from "lucide-react";

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <section className="bg-gradient-to-b from-blue-50/60 to-white border-b border-slate-200 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-50 border border-blue-200 text-brand text-xs font-bold">
            <RefreshCcw size={14} /> Legal
          </div>
          <h1 className="heading mt-5 text-4xl sm:text-5xl font-black">Refund Policy</h1>
          <p className="mt-3 text-slate-600">Last updated: April 2026</p>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-6 text-slate-700 leading-relaxed">
          <H>1. Donations</H>
          <p>All donations made to PMR Welfare Foundation are <b>voluntary, non-refundable</b> and deployed towards our charitable programs within <b>30 working days</b> of receipt. We operate as a Section 8 Company under the Companies Act, 2013 and are audited annually.</p>
          <p>However, refunds may be considered in the following exceptional cases:</p>
          <ul className="list-disc list-outside ml-6 space-y-2">
            <li><b>Duplicate transaction:</b> If the same donation is charged twice due to a technical error, the duplicate amount will be refunded within 7–10 working days of verification.</li>
            <li><b>Unauthorized transaction:</b> If a donation was made without the account-holder's authorization, please notify us within <b>48 hours</b> along with supporting bank proof.</li>
            <li><b>Incorrect amount:</b> If an obvious typographical error (e.g., ₹50,000 instead of ₹500) is reported within 24 hours, we may initiate a partial refund at our discretion.</li>
          </ul>

          <H>2. Test Series Fees</H>
          <ul className="list-disc list-outside ml-6 space-y-2">
            <li>Test-series enrollment fees are non-refundable once the exam has been attempted or the exam date has passed.</li>
            <li>If a scheduled test is cancelled or rescheduled by us, you will receive a full refund or a free transfer to the next batch at your option.</li>
            <li>Refund requests for technical failures during payment (double charge, failed enrollment despite debit) will be processed within 7–10 working days upon submission of the transaction reference.</li>
          </ul>

          <H>3. How to Request a Refund</H>
          <p>Email <a className="text-brand font-bold" href="mailto:contact@pmrwelfarefoundation.in">contact@pmrwelfarefoundation.in</a> with:</p>
          <ul className="list-disc list-outside ml-6 space-y-2">
            <li>Transaction ID / PayU reference</li>
            <li>Date and amount</li>
            <li>Reason for refund</li>
            <li>Bank statement snippet (if applicable)</li>
          </ul>
          <p>Our team will acknowledge your request within <b>2 working days</b> and resolve it within <b>7–10 working days</b>.</p>

          <H>4. Mode of Refund</H>
          <p>Approved refunds will be credited back to the <b>original payment source</b> (credit card, debit card, net-banking, UPI or wallet). We do not issue cash or cheque refunds.</p>

          <H>5. 80G Receipt Reversal</H>
          <p>If a donation is refunded, the corresponding 80G receipt is treated as cancelled. Please do not claim tax deduction on a refunded amount.</p>

          <H>6. Contact</H>
          <p>PMR Welfare Foundation · Ram Shyam Niketan Apartment, Nehru Nagar Rd, near Patliputra Police Station, Patna, Bihar 800001 · <b>+91 9155561892</b> · <a className="text-brand font-bold" href="mailto:contact@pmrwelfarefoundation.in">contact@pmrwelfarefoundation.in</a></p>
        </div>
      </section>
      <PublicFooter contact={null} />
      <WhatsAppButton />
    </div>
  );
}

function H({ children }) { return <h2 className="heading text-2xl font-black text-brand pt-4">{children}</h2>; }
